/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Disable_ButtonInputs */

const fr_totp_disable_button = /** @type {(inputs: Totp_Disable_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver le TOTP`)
};

/**

* @param {Totp_Disable_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_disable_button = /** @type {((inputs?: Totp_Disable_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Disable_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_disable_button(inputs)
});